export var convertToAbsoluteImageURI = function convertToAbsoluteImageURI(uri, uriPlaceholders) {
  var url = uri;
  var staticAssets = uriPlaceholders.staticAssets,
    scalingParam = uriPlaceholders.scalingParam,
    mode = uriPlaceholders.mode,
    _uriPlaceholders$ext = uriPlaceholders.ext,
    ext = _uriPlaceholders$ext === void 0 ? '' : _uriPlaceholders$ext,
    _uriPlaceholders$widt = uriPlaceholders.width,
    width = _uriPlaceholders$widt === void 0 ? '' : _uriPlaceholders$widt;
  if (uri && staticAssets && uri.indexOf('https://') === -1) {
    url = "".concat(staticAssets, "/").concat(uri);
  }
  url = url.replace('$scalingParam$', scalingParam);
  url = url.replace('$width$', width);
  url = url.replace('$mode$', mode);
  url = url.replace('$ext$', ext);
  return url;
};
export var computeImageSourceType = function computeImageSourceType(type) {
  switch (type) {
    case 'webp':
      return 'image/webp';
    case 'svg':
      return 'image/svg+xml';
    case 'png':
      return 'image/png';
    case 'gif':
      return 'image/gif';
    default:
      return 'image/jpeg';
  }
};